// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__lrI7h","errorLogs":"styles_errorLogs__WdKDz"};